export default (function (value) {
  return value === null || value === undefined;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isNil.js
// module id = ./node_modules/redux-actions/es/utils/isNil.js
// module chunks = 6 9 11